<!--
IMPORTANT:
This file is used only in the vue3 application
Any changes made here should be do in the vue2 file also
Any clarifications contact Divya

Vue2File : wwwroot\js\components\MegaMenu\MenuSpecials\MenuSpecials.vue
-->

<template>
  <div class="m-specials-container p-3 p-md-4">
    <h3 class="text-center mb-5">Specials</h3>
    <div v-if="paymentdata && paymentdata.length" class="container-fluid">
      <div class="row">
        <div v-for="(paymentoffer, index) in paymentdata" :key="index" class="special-box-container col-12" :class="[gridColumns]">
          <div class="h-100 special-box row p-3 mx-0 align-items-center">
            <div class="col-5 pl-0">
              <div class="car-img-container">
                <img
                  :src="paymentoffer.imageHandlerPath +`&autocrop=true&angle=01&vehicletype=${paymentoffer.vehicleType}`"
                  :alt="`${paymentoffer.modelYear} ${paymentoffer.divisionName} ${paymentoffer.modelName} ${paymentoffer.trim}`"
                  class="img-fluid offer-special-img"
                />
              </div>
            </div>
            <div class="col-7 pr-0">
              <div class="font-weight-bold _theme_font_bold">
                New {{ paymentoffer.modelYear }}
                {{ paymentoffer.divisionName }}
                {{ getModelAndTrimName(paymentoffer) }}
                {{ insertTradeMark(paymentoffer.styleNameWOTrim) }}
              </div>
              <div class="ft-12 my-2">
                <span class="font-weight-bold _theme_font_bold">
                  {{ paymentoffer.offertype }} for
                  {{ formatNumberInString(paymentoffer.offerText1) }} per month
                </span>
                <span>
                  {{ formatNumberInString(removePerMonthText(paymentoffer.offerText2)) }}
                  {{ formatNumberInString(paymentoffer.offerText3) }}
                </span>
                <div v-if="!hideExpirationDate">Expires {{ paymentoffer.endDate }}</div>
              </div>
              <div class="d-flex align-items-center ft-12">
                <a :href="paymentoffer.vehicleFullName && paymentoffer.vehicleFullName.toLowerCase()" class="no-hover text-underline pr-3 special-view-details-link">View Details</a>
                <span v-if="!showDisclaimerOnLoad" class="text-underline" @click.prevent="openDisclaimer(paymentoffer.disclaimerText)">Offer Disclosure</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <text-modal
      v-if="opentextmodal"
      :text="disclaimerText"
      :title="'Disclosure'"
      @hidemodal="opentextmodal = false"
    />
  </div>
</template>
<script>
import MenuSpecials from './MenuSpecials';
export default {
mixins: [MenuSpecials],
data() {
  return{
    gridColumns: window.menuStyleId !== '15' ? 'col-xl-6' : 'col-xxl-6'
  }
}
}
</script>
<style scoped>
.m-specials-container {
  border-radius: 25px;
  background-color: #F3F3F3;
  overflow: scroll;
}
.special-box-container {
  padding: 8px;
  min-height: 200px;
}
.special-box {
  background-color: #fff;
  border-radius: 15px;
}
.special-view-details-link {
  color: #333;
}
.special-view-details-link:hover {
  color: inherit;
  text-decoration: underline;
}
.car-img-container {
  overflow: hidden;
  border-radius: 10px;
}
.offer-special-img {
  transition: all 0.3s ease;
}
</style>
